<template>
  <v-dialog scrollable max-width="1200px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn color="info" small v-on="on" @click="cargar"
        >Anticipo Retroactivo</v-btn
      >
    </template>

    <v-card>
      <v-card-title>Anticipos</v-card-title>
      <v-card-text>
        <v-alert type="error" v-if="errorMessage">
          {{ errorMessage }}
        </v-alert>
        <v-alert type="success" v-if="message">
          {{ message }}
        </v-alert>
        Monto OP: {{montoOP | numberFormat}}
        <v-text-field type="text" label="Importe" v-model="importe" />
        <v-data-table
          :items="items"
          :headers="headers"
          show-select
          single-select
          item-key="idAnticipo"
          v-model="selected"
        >
          <!-- <template v-slot:[`item.monto`]="props">
            {{ props.item.monto | numberFormat }}
          </template>

          <template v-slot:[`item.beneficiario.nombreCompleto`]="props">
            {{ props.item.beneficiario.nombreCompleto }} CI:
            {{ props.item.beneficiario.cedula }}
          </template> -->

          <template v-slot:[`item.saldo`]="props">
            {{ props.item.saldo | numberFormat }}
          </template>

          <!-- <template v-slot:[`item.action`]="props">
            <v-btn v-if="props" small
              >Test
              <v-icon>save_alt</v-icon>
            </v-btn>
          </template> -->
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="showDialog = false">Volver</v-btn>
        <v-btn color="warning" @click="aplicar" v-if="habilitado"
          >APLICAR ANTICIPO</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import numeral from "numeral";
import moment from "moment";

export default {
  props: ["codMemSq", "ordenPagoId", "montoOP"], 
  data() {
    return {
      showDialog: false,
      items: [],
      selected: [],
      importe: "",
      errorMessage: "",
      message: "",
      headers: [
        { text: "Id", value: "idAnticipo" },
        { text: "Saldo", value: "saldo" },
        { text: "", value: "action" },
      ],
    };
  },
  methods: {
    aplicar() {
      const datos = {
        idAnticipo: this.selected[0].idAnticipo,
        ordenPagoId: this.ordenPagoId,
        monto: this.importe,
      };

      axios
        .post("/persona/aplicarAnticipoRetroactivo", datos)
        .then(() => {
          // this.items = res.data;
          // console.log(res);
          this.message = "EXITO!";
          this.selected = [];
        })
        .catch((err) => {
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    cargar() {
      this.errorMessage = "";
      axios
        .get("/persona/anticiposSaldos?codMemSq=" + this.codMemSq)
        .then((res) => {
          this.items = res.data;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    numberFormat(value) {
      if (!value) {
        return numeral(0).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
      if (value) {
        return numeral(value).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
  computed: {
    habilitado() {
      return this.selected.length == 1 && this.isNumeric(this.importe);
    },
  },
};
</script>